module.exports = __webpack_public_path__ + "img/wood2.2afe6368.jpg";